<template>
    <div>
        <el-row v-if="isShowTop">
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">订单管理</el-breadcrumb-item>
                    <el-breadcrumb-item>我的账户</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="0">
            <el-form :model="nowUser" class="demo-form-inline" size="mini">
                <el-form-item label="姓名：">
                    {{nowUser.userRealName}}
                </el-form-item>
                <el-form-item label="余额：">
                    {{nowUser.balance}} 元
                </el-form-item>
            </el-form>
            <el-table
            :data="transactions"
            :height="tableHeight"
            size="mini"
            border
            @selection-change="handleSelectionChange"
            ref="tb"
            style="width: 99%">
                <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                <el-table-column fixed prop="transactionTypeDesc" label="交易类型"></el-table-column>
                <el-table-column fixed prop="amountDesc" label="交易金额"></el-table-column>
                <el-table-column fixed prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="交易时间" width="200"></el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10,20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
                </el-pagination>
            </div>
        </el-row>
    </div>
    
</template>

<script>

    export default {
        name:'Transaction',
        props: ["userProp"],
        data() {
            return {
                transaction: {
                    condition:{
                    },
                    pageNum: 1,
                    pageSize:0
                },
                drawer: false,
                direction: 'rtl',
                transactions: [],
                currentPage: 1,
                pageSize:20,
                total:10,
                timer:'',
                tableHeight: "",//表格高度
                dialogFormVisible: false,
                addRegion:{
                    regionList:[{regionName : ""}]  //接收每个input框的值
                },
                updateDialog: false,
                updateRegion: {},
                selectedRegion: {},
                user:{},
                isShowTop: true,
                nowUser:{},
            }
        },
        methods: {
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryTransaction();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTransaction();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryTransaction();
                })
                .catch(() => {});
            },
            queryTransaction() {
                this.transaction.pageNum = this.currentPage;
                this.transaction.pageSize = this.pageSize;
                this.transaction.condition.userId = this.user.userId;
                this.$axios.post("/transaction/find",this.transaction).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.transactions = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            getTableHeight() {
                let tableH = 300; //距离页面下方的高度
                this.tableHeight = window.innerHeight - tableH;
            },
            toggleSelection(rows) {
                if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
                } else {
                this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(selection) {
                //this.multipleSelection = val;
                if (selection.length > 1) {
                    this.$refs.tb.clearSelection();
                    this.$refs.tb.toggleRowSelection(selection.pop());
                }else if (selection.length === 1) {
                    this.selectedRegion = selection.pop()
                } else {
                    this.selectedRegion = {}
                }
            },
            toAddRegion() {
                this.dialogFormVisible = true;
                while(this.addRegion.regionList.length > 0) {
                    this.addRegion.regionList.pop();
                }
                this.addRegion.regionList.push({
                    regionName: "",
                });
            },
            addItem() {
                this.addRegion.regionList.push({
                    regionName: "",
                });
            },
            deleteItem(i){
                if (this.addRegion.regionList.length <= 1) {
                    return false;
                }
                this.addRegion.regionList.splice(i, 1);
            },
            toUpdate(row) {
                this.updateRegion = row;
                this.updateDialog = true;
            },
            queryNowUser() {
                var param = {
                    id:this.user.userId
                }
                this.$axios.post("/user/findById",param).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.nowUser = res.data.result;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
        },
        mounted() {
        },
        created() {
            this.user = JSON.parse(window.localStorage.getItem("user"));
            if(this.userProp) {
                this.user = this.userProp;
                this.isShowTop = false;
            }
            this.queryTransaction();
            this.queryNowUser();
            this.getTableHeight();
        }
        
    }


</script>

<style scoped>

   .el-row {
       margin-top: 30px;
       text-align: left;
       padding-left: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }

</style>
